<script>
  import Bar from './Bar.svelte';

  export let value;
  export let numericValue;
  export let max;
</script>

<div>
  {value}
  <Bar value={numericValue} {max} />
</div>

<style>
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    width: 100%;
  }
</style>